import { render, staticRenderFns } from "./AddEditItemDialog.vue?vue&type=template&id=6a61d230&scoped=true&"
import script from "./AddEditItemDialog.vue?vue&type=script&lang=js&"
export * from "./AddEditItemDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a61d230",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a61d230')) {
      api.createRecord('6a61d230', component.options)
    } else {
      api.reload('6a61d230', component.options)
    }
    module.hot.accept("./AddEditItemDialog.vue?vue&type=template&id=6a61d230&scoped=true&", function () {
      api.rerender('6a61d230', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/report/project-detail/WallList/AddEditItemDialog.vue"
export default component.exports